import React from 'react';
import {
  List, ListItem, ListItemText, ListItemAvatar, Avatar,
} from '@mui/material';
import { getAssets } from 'themes/assets';
import { _t } from 'utils';

export default () => {
  const assets = getAssets();

  const centers = [
    {
      name: _t('Germany / Frankfurt am Main'),
      image: assets.DE,
      hdd: 'ftp://ftp-fra.ionos.com/hdd-images',
      iso: 'ftp://ftp-fra.ionos.com/iso-images',
    },
    {
      name: _t('Germany / Karlsruhe'),
      image: assets.DE,
      hdd: 'ftp://ftp-fkb.ionos.com/hdd-images',
      iso: 'ftp://ftp-fkb.ionos.com/iso-images',
    },
    {
      name: _t('USA / Las Vegas (NV)'),
      image: assets.US,
      hdd: 'ftp://ftp-las.ionos.com/hdd-images',
      iso: 'ftp://ftp-las.ionos.com/iso-images',
    },
    {
      name: _t('USA / Newark (NJ)'),
      image: assets.US,
      hdd: 'ftp://ftp-ewr.ionos.com/hdd-images',
      iso: 'ftp://ftp-ewr.ionos.com/iso-images',
    },
    {
      name: _t('Germany / Berlin'),
      image: assets.DE,
      hdd: 'ftp://ftp-txl.ionos.com/hdd-images',
      iso: 'ftp://ftp-txl.ionos.com/iso-images',
    },
    {
      name: _t('United Kingdom / London'),
      image: assets.UK,
      hdd: 'ftp://ftp-lhr.ionos.com/hdd-images',
      iso: 'ftp://ftp-lhr.ionos.com/iso-images',
    },
  ];

  return (
    <div className="upload">
      <p style={{ margin: '5px 0', fontWeight: 'bold' }}>{_t('You can upload images using FTP with TLS.')}</p>
      <p style={{ margin: '8px 0' }}>
        {_t(
          'Connect to the FTP of the target region using your username and password and upload your image.',
        )}
        {' '}
        {_t(
          'Once your upload completes you will receive a notification by email and the image will become available shortly after being processed.',
        )}
      </p>

      <List>
        {centers.map(({
          name, image, hdd, iso,
        }) => (
          <ListItem alignItems="flex-start" key={name}>
            <ListItemAvatar>
              <Avatar alt={name} src={image} />
            </ListItemAvatar>
            <ListItemText
              primary={name}
              secondary={(
                <span className="links">
                  <span>
                    <strong>HDD</strong>
                    {hdd}
                  </span>
                  <span>
                    <strong>ISO</strong>
                    {iso}
                  </span>
                </span>
              )}
            />
          </ListItem>
        ))}
      </List>
      <p style={{ margin: '0' }}>
        {_t(
          'In order to make an image available in multiple regions you have to upload it into each region where the image is needed.',
        )}
      </p>
    </div>
  );
};
